function assertInt(num) {
  if (!Number.isNaN(num)) {
    return true;
  }
  throw new Error("Error: Cannot use numbers with decimal points.");
}

/**
 * Converts the value to a Number if necessary.
 *
 * @param {any} value
 * @returns {number}
 * @throws {Error} if the value is not a number, or string, or if the
 *   number or string value is not integral
 */
function ensureInt(value) {
  switch (typeof value) {
    case "number":
      return value;
    case "bigint":
    case "string":
      const numValue = Number(value);
      assertInt(numValue);
      return numValue;
    default:
      throw new Error(`Error: Invalid type (${typeof value}) for value`);
  }
}

/**
 * Returns a formatter function which accepts a Tilia currency display value  as a Number,
 * Number, or string, and returns the raw integer by using the minor_unit.
 *
 * @param {string} currency
 * @param {CurrencyInfo} currencyInfo
 * @returns {function(value: Number|string): string}
 */
function getRawCurrencyValue(currency, currencyInfo) {
  let minorUnit; // fraction digits

  if (Object.prototype.hasOwnProperty.call(currencyInfo, currency)) {
    const virtualCurrency = currencyInfo[currency];

    minorUnit = virtualCurrency.minor_unit;
  } else {
    // case of when it's not a virtual currency but a real currency
    minorUnit = 2;
  }

  return (value) => {
    value = ensureInt(value);

    if (value > Number.MAX_SAFE_INTEGER) {
      throw new Error("Error: value is greater than than Number.MAX_SAFE_INTEGER");
    }

    // for floating point error, we will round it because we want the whole number,
    // the decimals don't matter
    return Math.round(value * 10 ** minorUnit);
  };
}

export default getRawCurrencyValue;
